module.exports = __webpack_public_path__ + "static/img/Frame11.9662ef2d.png";